import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { GridFilter, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { DebtorCreditorNoticesHeader } from "../../models/debtor-creditor-notices-header.model";
import { DebtorCreditorNoticesHeaderFormComponent } from "../debtor-creditor-notices-header-form/debtor-creditor-notices-header-form.component";

@Component({
  selector: "ngx-debtor-creditor-notices-header-list",
  templateUrl: "./debtor-creditor-notices-header-list.component.html",
  styleUrls: ["./debtor-creditor-notices-header-list.component.scss"],
})
export class DebtorCreditorNoticesHeaderListComponent extends BaseListComponent {
  filterInfo: NameValue[] = [];
  constructor(private splashFormService: SplashFormService) {
    super();
    this.inputEditorform = DebtorCreditorNoticesHeaderFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    let currentFiscalYear = this.accountService.authService.currentFiscalYear;
    this.setactions();
    this.apiName = "DebtorCreditorNoticesHeader";
    this.areaName = "SellCustomer";
    this.label = "فهرست اعلامیه بدهکار بستانکار";
    if (this.accountService.authService.currentFiscalYear) {
      this.filterInfo.push({ Name: "FiscalYearId", Value: this.accountService.authService.currentFiscalYear?.Id, Operator: "eq" });
      this.filterInfo.push({ Name: "BranchId", Value: this.accountService.authService.currentBranchId, Operator: "eq" });
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.filterInfo.push({ Name: "FiscalYearId", Value: x.Id, Operator: "eq" });
          this.filterInfo.push({ Name: "BranchId", Value: this.accountService.authService.currentBranchId, Operator: "eq" });
        }
      });
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: DebtorCreditorNoticesHeader,
    onRowsSelected: DebtorCreditorNoticesHeader[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    ///انتقال مانده مشتریان
    this.splashFormService.openDialog("", action.name === "CustomersAccountClosing" ? "در حال انتقال مانده مشتری" : "در حال برگشت مانده مشتری");
    this.httpCommonService
      .create(action.apiName, this.accountService.authService.currentFiscalYear)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          if (x) {
            this.splashFormService.closeLoading();
            this.sts.showDialog(action.name === "CustomersAccountClosing" ? "مانده مشتری با موفقیت منتقل شد." : "مانده مشتری با موفقیت برشکت.", "");
            this.ngOnInit();
          }
        },
        (error) => {
          this.sts.showDialog(
            action.name === "CustomersAccountClosing"
              ? `خطا در انتقال مانده مشتری ${Utilities.getHttpResponseMessage(error)}`
              : `خطا در برگشت ماند مشتری ${Utilities.getHttpResponseMessage(error)}`,
            "خطا"
          );
          this.ngOnInit();
          this.splashFormService.closeLoading();
        }
      );
    return;
  }
  setactions() {
    this.actions = [
      {
        name: "CustomersAccountClosing",
        disabled: false,
        displayName: "انتقال مانده مشتریان",
        iconName: "icon-create_new_folder-o",
        apiName: "DebtorCreditorNoticesHeader/CustomersAccountClosing",
        areaName: "SellCustomer",
        permission: Permission.samePermission,
      },
      {
        name: "CustomersRetunRemain",
        disabled: false,
        displayName: "برگشت مانده مشتریان",
        iconName: "icon-delete-sweep-outline",
        apiName: "DebtorCreditorNoticesHeader/CustomersRetunRemain",
        areaName: "SellCustomer",
        permission: Permission.samePermission,
      },
    ];
  }
}
